export const METAL = "Metal",
  DIELECTRIC = "Dielectric",
  LAMINATE = "Laminate",
  MULTI_ZONE = "Multizone";;
